export default __webpack_public_path__ + "static/media/ColorShiftRequirement.b4dc744f.svg";